/**
 * Landing Press Release (Bison) – horizontal scroll via arrow buttons
 */
(function () {
  function init() {
    document.querySelectorAll('.landing-press-release-bison').forEach(function (section) {
      var scrollEl = section.querySelector('[data-press-scroll]');
      var prevBtn = section.querySelector('[data-press-prev]');
      var nextBtn = section.querySelector('[data-press-next]');
      if (!scrollEl || !prevBtn || !nextBtn) return;

      var scrollAmount = 340;

      prevBtn.addEventListener('click', function () {
        scrollEl.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        scrollEl.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
